import React from 'react'

import { Helmet } from 'react-helmet'

import TopMenu from '../components/top-menu'
import Footer from '../components/footer'
import './dexter.css'

const Dexter = (props) => {
  return (
    <div className="dexter-container10">
      <Helmet>
        <title>Dexter DEX Design Case Study | Vlad Butucariu</title>
        <meta
          name="description"
          content="UX/UI, interface, and brand design for Dexter, a decentralized exchange built for the Radix ecosystem."
        />
        <meta
          property="og:title"
          content="Dexter DEX Design Case Study | Vlad Butucariu"
        />
        <meta
          property="og:description"
          content="Designing a structured trading interface and visual identity for a technical financial product."
        />
        <meta
          property="og:image"
          content="https://vladbutucariu.com/Images/og-default.png"
        />
        <link rel="canonical" href="https://vladbutucariu.com/dexter" />
        <meta property="og:url" content="https://vladbutucariu.com/dexter" />
      </Helmet>
      <div className="dexter-thq-wrapper-elm">
        <TopMenu text3="Capabilities"></TopMenu>
        <div className="dexter-thq-top-section-elm">
          <div className="dexter-thq-video-div-elm">
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="dexter-video"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="dexter-thq-video-mobile-elm"
            ></video>
          </div>
          <div className="dexter-thq-section-elm1">
            <div className="dexter-thq-color-wrapper-elm1 project-page-shell">
              <div className="dexter-container11 project-page-intro">
                <div className="dexter-container12">
                  <img
                    alt="image"
                    src="/Images/tickerpurple.200.svg"
                    className="dexter-image10"
                  />
                  <div className="dexter-container13">
                    <h1 className="header-project">DEXTER DEX</h1>
                    <div className="dexter-container14">
                      <span className="dexter-text11">
                        generative vector art
                      </span>
                      <span className="dexter-text12">on ledger</span>
                    </div>
                  </div>
                  <h2 className="dexter-text13">
                    <span>
                      Sparked as a fully community backed project, the
                      decentralised DEX has a minimal yet fresh interface to
                      kick fast the development and simplify visual
                      reproduction.
                    </span>
                    <br></br>
                    <br></br>
                    <span>
                      What seemed like a fun social experiment for building
                      decentralised platforms, the project attracted the
                      curiosity of our team and motivation to build fast a
                      barebone user interface and branding that can be easily
                      replicated and implemented by the developers without too
                      much troubles. That catchy name came with the package.
                    </span>
                    <br></br>
                  </h2>
                </div>
                <div className="dexter-container15">
                  <img
                    alt="image"
                    src="/Projects/dexter%20dex%20logo.png"
                    className="dexter-image11"
                  />
                  <div className="dexter-container16">
                    <div className="dexter-container17">
                      <label className="dexter-text19 tag-label-big">
                        exchange
                      </label>
                      <label className="dexter-text20 tag-label-big">
                        logo
                      </label>
                      <label className="dexter-text21 tag-label-big">ui</label>
                    </div>
                    <div className="dexter-thq-counter-elm">
                      <a
                        href="https://dexteronradix.com"
                        target="_blank"
                        rel="noreferrer noopener"
                        className="dexter-link"
                      >
                        https://dexteronradix.com
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="dexter-thq-section-elm2">
          <div className="dexter-thq-label-elm">
            <span className="dexter-text24">Loopers</span>
            <span className="dexter-text25">
              animation, nft, collection, art
            </span>
          </div>
          <div className="dexter-container21">
            <div className="dexter-thq-item-elm10">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="dexter-image12"
              />
            </div>
            <div className="dexter-thq-item-elm11">
              <img
                alt="image"
                src="/Images/alwayslate2.svg"
                className="dexter-image13"
              />
            </div>
            <div className="dexter-thq-item-elm12">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="dexter-image14"
              />
            </div>
            <div className="dexter-thq-item-elm13">
              <img
                alt="image"
                src="/Images/alwayslate4.svg"
                className="dexter-image15"
              />
            </div>
            <div className="dexter-thq-item-elm14">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="dexter-image16"
              />
            </div>
            <div className="dexter-thq-item-elm15">
              <img
                alt="image"
                src="/Images/alwayslate6.svg"
                className="dexter-image17"
              />
            </div>
            <div className="dexter-thq-item-elm16">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="dexter-image18"
              />
            </div>
            <div className="dexter-thq-item-elm17">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="dexter-image19"
              />
            </div>
            <div className="dexter-thq-item-elm18">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="dexter-image20"
              />
            </div>
            <div className="dexter-thq-item-elm19">
              <img
                alt="image"
                src="/Images/alwayslate2.svg"
                className="dexter-image21"
              />
            </div>
            <div className="dexter-thq-item-elm20">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="dexter-image22"
              />
            </div>
            <div className="dexter-thq-item-elm21">
              <img
                alt="image"
                src="/Images/alwayslate4.svg"
                className="dexter-image23"
              />
            </div>
            <div className="dexter-thq-item-elm22">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="dexter-image24"
              />
            </div>
            <div className="dexter-thq-item-elm23">
              <img
                alt="image"
                src="/Images/alwayslate6.svg"
                className="dexter-image25"
              />
            </div>
            <div className="dexter-thq-item-elm24">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="dexter-image26"
              />
            </div>
            <div className="dexter-thq-item-elm25">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="dexter-image27"
              />
            </div>
            <div className="dexter-thq-item-elm26">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="dexter-image28"
              />
            </div>
            <div className="dexter-thq-item-elm27">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="dexter-image29"
              />
            </div>
          </div>
        </div>
        <div className="dexter-thq-section-elm3">
          <div className="dexter-thq-color-wrapper-elm2">
            <div className="dexter-container22">
              <div className="dexter-thq-pic-elm1">
                <div className="dexter-thq-description-elm1">
                  <p className="dexter-text26">
                    The trading UI of the app uses a simple grid with sharp
                    delimitations between the different utility panels. Based on
                    the hierarchy of the actions available in the app, the
                    elements are highlighted accordingly. Panels such as the
                    Swapping token one pops up with lighter colors, while
                    passive panels such as the Order Book blend in the
                    background. 
                  </p>
                </div>
                <img
                  alt="image"
                  src="/Projects/dexter%20-%20trading%20page.png"
                  className="dexter-image30"
                />
              </div>
              <div className="dexter-thq-pic-elm2">
                <div className="dexter-thq-description-elm2">
                  <p className="dexter-text27">
                    The homepage of the project follows within the same
                    guidelines, with a sharp geometric layout and a straight
                    informative table with all the token pairs listed on the
                    DEX, and summaries about the milestones reached in terms of
                    volume, pairs, liquidity and so forth.
                  </p>
                </div>
                <img
                  alt="image"
                  src="/Projects/dexter%20-%20landing%20page.png"
                  className="dexter-image31"
                />
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
  )
}

export default Dexter
